import InitFlerApptus from "./initFlerApptus";

export default function InsertPager(totalCount, pageIndex, isMerAv) {
	var $showMore = $('.show_more');

	if (totalCount <= parseInt($(".selVisaFler").val())) {
		$showMore.find('.pagination').remove();
		return;
	}

	var pager = InitFlerApptus(totalCount, pageIndex, isMerAv);
	if ($showMore.find('.pagination').length == 0) {
		$showMore.append(pager);
	}
	else {
		$showMore.find('.pagination').replaceWith(pager);
	}
}